import { makeStyles } from '@material-ui/styles';

import { Text, MainButton } from '@bizzabo/design-system';
import { useCurrentUser, useUpdateCurrentUser } from '@bizzabo/entities';

import { useMessages } from '../../../contexts/MessagesContext';
import useTypeTracking from '../../../../../analytics';
import CardMessageWrapper from '../CardMessageWrapper';

const HiddenView: React.FC = () => {
    const { eventId } = useMessages();
    const { data: currentUser } = useCurrentUser(eventId);
    const updateCurrentUser = useUpdateCurrentUser();
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();

    const handleUnhideProfile = () => {
        updateCurrentUser({ eventId, userProfileId: currentUser.id, payload: { isHidden: false } });
        trackClickEvent({
            subCategory: 'PROFILE_UNHIDE',
        });
    };

    return (
        <div className={classes.wrapper}>
            <CardMessageWrapper>
                <div className={classes.title}>
                    <span className={classes.emoji}>🙈</span>
                </div>
                <Text variant="t81" className={classes.text}>
                    Your profile is hidden. Allow to show it in order to send/get personal messages
                </Text>
                <div className={classes.btnContainer}>
                    <MainButton
                        variant="fill"
                        className={classes.btn}
                        onClick={handleUnhideProfile}
                    >
                        Unhide my profile
                    </MainButton>
                </div>
            </CardMessageWrapper>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        wrapper: {
            height: '100%',
            backgroundColor: theme.palette.greys[100],
            borderRadius: '0 0 33px 33px',
        },
        title: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: theme.palette.greys[700],
        },
        text: {
            margin: '10px 0 20px',
            textAlign: 'center',
            color: theme.palette.greys[600],
        },
        emoji: {
            marginBottom: 6,
            marginLeft: 4,
            fontSize: '1.6rem',
        },
        btnContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        btn: {
            ...theme.typography.t80,
            height: 24,
            padding: '0 13px',
        },
    }),
    { classNamePrefix: 'private-chat-hidden-view' }
);

export default HiddenView;
